/** Como a matriz estratégica agrupa as bolhas — espelho de
 *  `core/vocabulary.py::DASHBOARD_MATRIX_GROUPS`, na mesma sequência
 *  (é a ordem dos botões). Paridade por fonte em
 *  `tests/test_dashboard_matrix_vocabulary_parity.py`. */
export const DASHBOARD_MATRIX_GROUPS = ["all", "brand", "spokesperson", "theme_group", "theme", "period"] as const;

export type DashboardMatrixGroup = (typeof DASHBOARD_MATRIX_GROUPS)[number];
